import api from "../lib/axios";

const authHeaders = (token) =>
  token ? { Authorization: `Bearer ${token}` } : {};

/**
 * Fetch exhibitor requests with filters and pagination.
 */
export const getExhibitorRequests = async (params, token) => {
  return api.get(`/exhibitor/request/list`, {
    params: {
      ...params,
      include_notes: "true",
      booth_details: "true",
    },
    headers: {
      ...authHeaders(token),
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch dynamic form fields for exhibitor requests.
 */
export const getExhibitorRequestForm = async (eventId, fieldDisplayContextId = null) => {
  return api.get(`/exhibitor/request/form/${eventId}`, {
    params: {
      field_display_context_id: fieldDisplayContextId,
    },
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Update exhibitor request status (e.g., in_review, rejected).
 */
export const updateExhibitorRequestStatus = async (data, token) => {
  return api.put(`/exhibitor/updateStatus`, data, {
    headers: {
      ...authHeaders(token),
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Approve exhibitor request and assign booth.
 */
export const approveExhibitorRequest = async (data, token) => {
  return api.put(`/exhibitor/approve`, data, {
    headers: {
      ...authHeaders(token),
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Add or update a note for an exhibitor request.
 */
export const saveExhibitorRequestNote = async (data, token) => {
  return api.post(`/exhibitor/request/note`, data, {
    headers: {
      ...authHeaders(token),
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Delete a note from an exhibitor request.
 */
export const deleteExhibitorRequestNote = async (noteId, token) => {
  return api.delete(`/exhibitor/request/note/${noteId}`, {
    headers: {
      ...authHeaders(token),
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Submit or update an exhibitor request (Form Data).
 */
export const submitExhibitorRequest = async (formData, token, requestId = null) => {
  console.log(formData);
  
  const url = requestId 
    ? `/exhibitor/request/update/${requestId}`
    : `/exhibitor/request/submit`;
  const method = requestId ? 'put' : 'post';

  return api[method](url, formData, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "multipart/form-data",
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Submit dynamic additional profile fields (Context 2).
 */
export const submitAdditionalProfileInfo = async (data) => {
  const isFormData = data instanceof FormData;
  return api.post(`/exhibitor/request/profile/additional-info`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    },
  });
};
